import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  dutiesAndTaxesGuaranteed: {
    id: 'GLrhLg',
    defaultMessage: 'Duties and Taxes (Guaranteed)',
    description: 'Label for walleted duties and taxes line item',
  },
  dutiesAndTaxesEstimated: {
    id: 'qwGKxc',
    defaultMessage: 'Duties and Taxes (Estimated)',
    description: 'Label for non-walleted duties and taxes line item',
  },
  dutiesAndTaxesWalletedTooltip: {
    id: 'rrvVo/',
    defaultMessage: 'This is the guaranteed final cost for duties and taxes. No further adjustments will be made by the carrier.',
    description: 'Tooltip text for walleted duties and taxes line item',
  },
  dutiesAndTaxesNonWalletedTooltip: {
    id: '+OsnUp',
    defaultMessage: 'Duties and taxes are estimated. Final charges may differ and will be billed by your carrier.',
    description: 'Tooltip text for non-walleted duties and taxes line item',
  },
});
